(ns practitest.frontend.landing.whats-new
  (:require [practitest.frontend.components2.container-card :refer [container-card]]
            [practitest.frontend.common.i18n :refer [get-translation]]
            [practitest.frontend.init :as init]
            [practitest.frontend.common.utils :as utils]
            [practitest.frontend.components.icons :as icons]
            [re-frame.core :as re-frame]))

(defn whats-new-card
  "A card component for displaying a what's new item"
  [{:keys [image title description link]}]
  [:a.pt-whats-new-card {:href link :target "_blank"}
   [:div.pt-whats-new-card-image-container
    [:img.pt-whats-new-card-image {:src image :alt title}]]
   [:div.pt-whats-new-card-content
    [:h4.pt-whats-new-card-title title]
    [:p.pt-whats-new-card-description description]]])

(defn whats-new []
  (let [cards @(re-frame/subscribe [:landing/whats-new])]
    (when (seq cards)
      [:div.pt-section
       [:h3.pt-container-card-title [icons/mux-speaker] (get-translation "landing.whats-new" "What's New")]
       [:div.pt-whats-new-cards
        (for [[idx card] (map-indexed vector cards)]
          ^{:key idx}
          [whats-new-card card])]])))

;; Admin preview component that reads cards from data attribute
(defn- parse-cards-json [data-cards]
  (try
    (when data-cards
      (let [parsed (js->clj (js/JSON.parse data-cards) :keywordize-keys true)]
        ;; Convert object {1: {...}, 2: {...}} to sorted list
        (->> parsed
             (sort-by (comp js/parseInt name first))
             (map second))))
    (catch js/Error _e
      nil)))

(defn whats-new-preview-root [{:keys [data-cards]}]
  (let [cards (parse-cards-json data-cards)]
    [:div.pt-whats-new-cards
     (for [[idx card] (map-indexed vector cards)]
       ^{:key idx}
       [whats-new-card card])]))

(defn ^:export init-preview [webcomponent options]
  (init/init-ui! {:options      options
                  :webcomponent webcomponent
                  :root-view    whats-new-preview-root}))

(defn ^:dev/after-load remount-preview []
  (init/remount-roots "whats-new-preview-component"
                      whats-new-preview-root))

(utils/register-webcomponent! "whats-new-preview-component")
